var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.$style.container,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.containerClickHandler($event)}}},[_c('img',{class:_vm.$style.burgerIcon,attrs:{"src":require("@images/burger.svg"),"alt":"","width":"22","height":"16"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c19aedf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","vector":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BurgerMenu.vue
// module id = okSo
// module chunks = 0